import { Bones } from '@simplywallst/ui-core';
import { Text, Grid } from '@simplywallst/ui-core';

import { CountryISO } from '@/constants/countries';

interface Props {
  market: CountryISO;
}

export const MetricsEmptyState = ({ market }: Props) => {
  return (
    <Grid
      templateColumns="max-content max-content"
      gap="36px"
      alignItems="start"
    >
      <Grid
        templateRows="min-content 23px"
        templateRowsLg="min-content 26px"
        alignItems="center"
      >
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          Holdings
        </Text>
        <Bones minHeight="12px" maxWidth="50px" />
      </Grid>
      <Grid
        templateRows="min-content 23px"
        templateRowsLg="min-content 26px"
        alignItems="center"
      >
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          {market.toUpperCase()} Market
        </Text>
        <Bones minHeight="12px" maxWidth="50px" />
      </Grid>
    </Grid>
  );
};
